<template>
  <div class="col-lg-12 col-md-12 col-sm-12 form-control no-border">
    <label class="d-block mb-0 small text-muted">
      {{ $t("communication.comMessage.recipientLabel") }}
    </label>
    <q-select
      outlined
      use-input
      clearable
      v-model="destinations"
      :options="filteredOptions"
      :rules="[isRequired]"
      dense
      @filter="filterDestFn"
      multiple
      emit-value
      map-options
      input-debounce="0"
    > 

      <template v-slot:selected-item="scope">
        <q-chip
          removable
          dense
          @remove="scope.removeAtIndex(scope.index)"
          :tabindex="scope.tabindex"
          color="white"
          text-color="primary"
          class="badge badge-primary d-flex"
          @click.stop.prevent="abortDestFilter"
        >
          <span class="mr-2 font-weight-normal">
            {{
              $t(
                "communication.comMessage.".concat(
                  getSelectedRecipientLabel(scope).context
                )
              )
            }}
          </span>
          -
          {{ getSelectedRecipientLabel(scope).id }}
        </q-chip>
      </template>
      <template v-slot:before-options>
        <div class="theme-1">
          <div :class="'tw-wrapper-recipients-' + recipientType">
            <div
              class="align-items-center d-flex justify-content-end p-2"
              style="gap: 10px"
            >
              <span class="tw-recipient-selector-All" @click="recipientType = 'All'">
                {{ $t("communication.comMessage.All") }}
              </span>
              <span class="tw-recipient-selector-User" @click="recipientType = 'User'">
                {{ $t("communication.comMessage.User") }}
              </span>
              <span class="tw-recipient-selector-Group" @click="recipientType = 'Group'">
                {{ $t("communication.comMessage.Group") }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:option="scope">
        <div class="theme-1">
          <div :class="'tw-wrapper-recipients-' + recipientType">
            <div
              class="border p-2"
              :class="'tw-option-for-' + getSelectedRecipientLabel(scope).context"
              :key="getSelectedRecipientLabel(scope)"
              clickable
              v-ripple
              v-close-popup
              v-bind="scope.itemProps"
            >
              <div class="d-flex align-items-center">
                <span class="badge badge-primary">
                  {{
                    $t(
                      "communication.comMessage.".concat(
                        getSelectedRecipientLabel(scope).context
                      )
                    )
                  }}
                </span>
                <span class="ml-2">
                  {{ getSelectedRecipientLabel(scope).id }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> {{ $t("main.noResults") }} </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import i18n from "@/i18n";

@Options({
  name: "comboRecipients",
  components: {},
  computed: {},
  props: {
    recipients: {
      type: Object,
      default: () => ({}), // set default value as an empty object
    },
    metadata: {
      type: Object,
      default: () => ({}), // set default value as an empty object
    },
  },
})
export default class comboRecipients extends Vue {
  recipientType?: string = "All";
  destinations: any = [];
  //holding original dests list
  optionsRecipient: any = [];
  recipients: any;
  metadata:any;

  get filteredOptions() {
    let odm: any;
    switch (this.recipientType) {
      case "All":
        odm = null;
        break;

      case "User":
        odm = "odm.user.leaseforgeuser";
        break;

      case "Group":
        odm = "odm.user.securitygroup";
        break;

      default:
        break;
    }
    const daaq = (this.metadata && Array.isArray(this.metadata)) ? this.metadata.find((meta: any) => meta.key === "Entity_Daaq")?.value : null;
    //In case is not related to an entity
    if (daaq && daaq!='null'){
      const recipientList=this.optionsRecipient.filter((option: any) =>  daaq?.includes(option.read_daaq))
      return odm !== null
      ? recipientList.filter((option: any) => option.objectType === odm)
      : recipientList;
    }
    return odm !== null
      ? this.optionsRecipient.filter((option: any) => option.objectType === odm)
      : this.optionsRecipient;
    
  }

  /**
   *  filter recipients options with input value
   * @param val
   * @param update
   */
  filterDestFn(val: string, update: any) {
    if (val === "") {
      this.optionsRecipient = this.recipients;
      update(this.recipients);
      return;
    }

    const needle = val.toLowerCase();
    const filteredList = this.optionsRecipient.filter((dest: any) => {
      if ("firstName" in dest) {
        // check if object has 'firstName' property
        return (
          dest.firstName.toLowerCase().includes(needle.toLowerCase()) ||
          dest.lastName.toLowerCase().includes(needle.toLowerCase()) ||
          dest.firstName.concat(' ').concat(dest.lastName).toLowerCase().includes(needle.toLowerCase()) ||
          dest.resourceUid.toLowerCase().includes(needle.toLowerCase())
        );
      } else {
        // check if object has 'label' and 'value' properties
         

        return (
           
          dest.resourceUid.toLowerCase().includes(needle.toLowerCase())
        );
      }
    });

    //
    this.optionsRecipient = filteredList;
    update(filteredList);
  }

  /**
   * abort recipients filter
   */
  abortDestFilter() {
    // reset to original list
    this.optionsRecipient = this.recipients;
  }
  isRequired(val: string | any[]) {
    return (
      (val && val.length > 0) || i18n.global.t("communication.comMessage.missingField")
    );
  }
  /**
     * This function retrieves the selected recipient tag in the given scope.
     @param {any} scope - The scope to retrieve the selected tag.
     @returns {string} - The selected tag in the given scope.
     */
  getSelectedRecipientLabel(scope: any) {
    if (scope.opt.username) {
      return {
        id: scope.opt.firstName + " " + scope.opt.lastName,
        context: "User",
      };
    } else {
      return { 
        id: scope.opt.resourceUid,
        context: "Group",
      };
    }
  }
}
</script>

<style scoped></style>
